<template>
  <div class="environment">
    <div
      class="label"
      ref="label"
      :style="{ transform: `translateY(${translateY}px)` }"
    >
      <div class="label-name">ENVIRONMENT</div>
    </div>

    <div class="container">
      <div class="main-img"><img :src="images.workspaceMain" /></div>
      <div class="conatiner-bottom">
        <div class="reasons">
          <Reason :icon="images.icon01" title="Taipei city view"></Reason>
          <Reason :icon="images.icon03" title="Free coffee & snacks"></Reason>
        </div>
        <div class="images">
          <div class="img-top"><img :src="images.workspace01" /></div>
          <div class="img-bottom">
            <div class="img-bottom-left"><img :src="images.workspace02" /></div>
            <div class="img-bottom-right">
              <img :src="images.workspace03" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Reason from "./Reason.vue";

import workspaceMain from "../../static/images/sectionWork/2025/workspace-01.jpg";
import workspace01 from "../../static/images/sectionWork/workspace-pic01.jpg";
import workspace02 from "../../static/images/sectionWork/workspace-pic02.jpg";
import workspace03 from "../../static/images/sectionWork/workspace-pic03.jpg";
import icon01 from "../../static/images/sectionWork/workspace-icon01.png";
import icon02 from "../../static/images/sectionWork/workspace-icon02.png";
import icon03 from "../../static/images/sectionWork/workspace-icon03.png";

export default {
  name: "Environment",
  components: {
    Reason,
  },
  data: () => {
    return {
      images: {
        workspaceMain: workspaceMain,
        workspace01: workspace01,
        workspace02: workspace02,
        workspace03: workspace03,
        icon01: icon01,
        icon02: icon02,
        icon03: icon03,
      },
      parallaxConfig: {
        execute: true,
        start: -50,
        end: 50,
        translateTop: 40,
        translateBottom: -40,
      },
      label: {
        el: null,
        top: null,
        bottom: null,
      },
      scrollY: 0,
      translateY: 0,
    };
  },
  methods: {
    getScrollY: function () {
      this.scrollY = window.scrollY;
    },
    getLabelValue: function () {
      if (this.label.el) {
        this.label.top = this.label.el.offsetTop;
        this.label.bottom =
          this.label.el.offsetTop + this.label.el.offsetHeight;
        return true;
      }
      return false;
    },
    map: function (
      value,
      currentLower,
      currentUpper,
      targetLower,
      targetUpper
    ) {
      return (
        ((value - currentLower) * (targetUpper - targetLower)) /
          (currentUpper - currentLower) +
        targetLower
      );
    },
    parallax: function () {
      this.getScrollY();
      const hasLabelValue = this.getLabelValue();

      if (hasLabelValue && this.parallaxConfig.execute) {
        const upperBound =
          this.label.bottom - window.innerHeight - this.parallaxConfig.end;
        const lowerBound = this.label.top + this.parallaxConfig.start;

        if (this.scrollY < upperBound) {
          this.translateY = this.parallaxConfig.translateTop;
        } else if (this.scrollY > upperBound && this.scrollY < lowerBound) {
          this.translateY = this.map(
            scrollY - this.parallaxConfig.start,
            upperBound,
            lowerBound,
            this.parallaxConfig.translateTop,
            this.parallaxConfig.translateBottom
          );
        } else {
          this.translateY = this.parallaxConfig.translateBottom;
        }
      } else {
        this.translateY = 0;
      }
    },
    handleResize: function () {
      const winWidth = window.innerWidth;
      if (winWidth <= 768) {
        this.parallaxConfig.execute = false;
      } else {
        this.parallaxConfig.execute = true;
      }
    },
  },
  mounted: function () {
    this.label.el = this.$refs.label;
    this.label.top = this.label.el.offsetTop;
    this.label.bottom = this.label.el.offsetTop + this.label.el.offsetHeight;
    this.handleResize();
  },
  created: function () {
    window.addEventListener("scroll", this.parallax);
    window.addEventListener("resize", this.handleResize);
  },
  destroyed: function () {
    window.removeEventListener("scroll", this.parallax);
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>

<style scoped lang="scss">
@import "../../static/styles/palette.scss";

.environment {
  margin-top: -150px;

  & .label {
    display: flex;
    justify-content: flex-end;
    position: relative;
    top: 480px;
    width: calc((100% - 925px) / 2 + 150px);
    min-width: 526px;
    height: 180px;
    border: 6px solid $blue;
    border-left: 0;
    z-index: 3;

    & .label-name {
      margin: 90px 30px 0 0;
      font-family: "Fugaz One";
      font-size: 44px;
      letter-spacing: 5.4px;
      color: $blue;
    }
  }

  .container {
    width: 925px;
    margin: 0 auto;

    & .main-img {
      position: relative;
      width: 100%;
      height: 365px;
      overflow: hidden;

      & img {
        position: absolute;
        object-fit: cover;
        object-position: 0 -100px;
        bottom: 0;
        width: 100%;
        height: auto;

        @media all and (min-width: 769px) {
          top: -100px;
        }
      }
    }

    & .conatiner-bottom {
      display: flex;
      justify-content: space-between;
      margin-top: 50px;

      & .reasons {
        margin-top: 130px;
      }

      & .images {
        width: 480px;
        position: relative;

        & .img-top {
          position: relative;
          width: 100%;
          height: 240px;
          margin-bottom: 10px;
          overflow: hidden;

          & img {
            position: absolute;
            width: 100%;
            bottom: 0;
          }
        }

        & .img-bottom {
          display: flex;
          justify-content: space-between;
          margin-top: 20px;

          & .img-bottom-left {
            & img {
              object-position: -5px 20px;
            }
          }

          & .img-bottom-left,
          & .img-bottom-right {
            width: 48%;
            height: 130px;
            position: relative;
            overflow-y: hidden;

            & img {
              position: absolute;
              width: 100%;
              height: auto;
              bottom: 0;
            }
          }
        }
      }
    }
  }
}

@media all and (max-width: 1200px) {
  .environment {
    margin-top: -160px;

    & .label {
      width: 440px;
      min-width: auto;
      height: 160px;
      top: 450px;

      & .label-name {
        font-size: 35px;
      }
    }

    .container {
      width: 80%;

      & .conatiner-bottom {
        & .reasons {
          margin-top: 160px;
        }

        & .images {
          margin-top: 60px;

          & .img-bottom {
            display: flex;
            justify-content: space-between;
            margin-top: 20px;

            & .img-bottom-left,
            & .img-bottom-right {
              height: 105px;
              overflow: hidden;
            }
          }
        }
      }
    }
  }
}

@media all and (max-width: 960px) {
  .environment {
    margin-top: -230px;
    margin-bottom: 40px;

    & .label {
      width: 380px;
      height: 150px;
      top: 440px;

      & .label-name {
        margin: 90px 30px 0 0;
        font-size: 30px;
      }
    }

    .container {
      width: calc(100% - 120px);

      & .conatiner-bottom {
        & .reasons {
          margin-top: 50px;
        }

        & .images {
          & .img-top {
            height: 150px;
          }

          & .img-bottom {
            & .img-bottom-left,
            & .img-bottom-right {
              height: 80px;
            }
          }
        }
      }
    }
  }
}

@media all and (max-width: 768px) {
  .environment {
    margin-top: 0;

    & .label {
      border: none;
      top: 0;
      width: 200px;
      height: auto;
      justify-content: flex-start;
      margin: -60px auto 20px 40px;
    }
    .container {
      width: calc(100% - 70px);

      & .main-img {
        position: relative;
        width: 100%;
        overflow: auto;
        height: auto;

        & img {
          position: relative;
          bottom: auto;
          object-fit: cover;
          object-position: 0 0;
        }
      }

      & .conatiner-bottom {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column-reverse;
        margin-top: -40px;

        & .reasons {
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 0;
        }

        & .images {
          position: relative;
          width: 100%;
          margin-top: 60px;
          overflow: auto;

          & .img-top {
            position: relative;
            width: 100%;
            overflow: auto !important;
            height: auto !important;

            & img {
              position: relative;
              bottom: auto;
            }
          }

          & .img-bottom {
            position: relative;
            width: 100%;
            overflow: auto !important;
            height: auto !important;
            flex-direction: column;

            & .img-bottom-left,
            & .img-bottom-right {
              position: relative;
              height: auto;
              width: 100%;
              overflow: auto;
              margin-bottom: 20px;

              & img {
                position: relative;
                bottom: auto;
              }
            }

            & .img-bottom-right {
              display: none;
            }
          }
        }
      }
    }
  }
}

@media all and (max-width: 480px) {
  .environment {
    & .label {
      & .label-name {
        margin: 90px 30px 0 -10px;
        font-size: 26px;
      }
    }

    & .container {
      width: calc(100% - 60px);
    }
  }
}

@media all and (max-width: 320px) {
  .environment {
    & .label {
      & .label-name {
        margin: 90px 30px 0 -20px;
      }
    }

    & .container {
      width: calc(100% - 40px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// Environment.vue?06534872